import "./LocalSeoConsultantWarrington.module.css";
import Header from "@/reusable_sections/Header";
import Casestudyimpact from "./sections/Casestudyimpact";
import Sectors from "./sections/Sectors";
import Methodology from "./sections/Methodology";
import Services from "./sections/Services";
import WarringtonLandscape from "./sections/WarringtonLandscape";
import Warringtonfaq from "./sections/Warringtonfaq";
import Localhero from "./sections/Localhero";
import ConsultantBenefits from "./sections/ConsultantBenefits";
import Warrington from "./sections/Warrington";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantWarringtonPage() {
  return <div>
      <Header />
      <Casestudyimpact />
      <Sectors />
      <Methodology />
      <Services />
      <WarringtonLandscape />
      <Warringtonfaq />
      <Localhero />
      <ConsultantBenefits />
      <Warrington />
      <Consultation />
      <Footer />
    </div>;
}